import { render, staticRenderFns } from "./RtcPrivateAcceptor.vue?vue&type=template&id=03714a01&scoped=true"
import script from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
export * from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
import style0 from "./RtcPrivateAcceptor.vue?vue&type=style&index=0&id=03714a01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03714a01",
  null
  
)

export default component.exports